<template>
	<LayoutExportacao>
		<div
			class="container__crud"
			style="width: 100% !important; max-width: 1500px !important; margin-left: 25px"
		>
			<div
				class="container__crudactions"
				style="display: flex"
			>
				<div class="container__crudactions_cruddownload">
					<div class="container__crudactions__cruddownload__crud" />
				</div>

				<Dropdown
					v-model="fazendasEscolhidas"
					style="padding-right: 20px; width: 100%"
					:label="$t('farm') + '*'"
					:options="fazendas"
				/>

				<Dropdown
					v-model="estratosEscolhidos"
					style="padding-right: 20px; width: 100%"
					:label="$t('forestStratification')"
					:options="estratos"
				/>
			</div>

			<div
				class="CheckboxExport"
				style="margin-top: 10px"
			>
				<!-- Título do grupo de checkboxes -->
				<h2 class="checkbox-title">
					{{ $t('inventoryType') }}
				</h2>
				<CheckboxGroup
					v-model="selectedExportOptions"
					:items="labels"
				/>
			</div>
			<div
				class="DatePicker"
				style="margin-top: 10px"
			>
				<h2 class="datepicker-title">
					{{ $t('measurementRange') }}
				</h2>

				<div
					class="datepicker-container"
					style="display: flex; align-items: center; gap: 10px"
				>
					<DatePickerInterval
						:label="$t('date')"
						:value="dataSelecionada"
						@input="handleDateChange"
					/>
					<ClearFiltersButton
						style="margin-left: auto; height: 50px"
						:text="$t('clearFilters')"
						@clear="limparFiltros"
					/>
					<ButtonUI
						style="margin-right: 20px !important; height: 50px"
						secondary
						:active="isActive"
						:text="$t('filterData')"
						@click="filtrar"
					/>
				</div>
			</div>

			<div class="table-container">
				<BaseTableWithPagination
					:data="data"
					:colunas="colunas"
					@update:checked="handleSelectionChange"
					@edit="handleEdit"
					@sortOptions="handleSortOptions"
				/>
			</div>
			<div
				v-if="data.length > 0"
				class="BaseTable"
				style="margin-top: 10px"
			>
				<ButtonUI
					style="margin-left: auto !important; margin-right: 20px !important; height: 50px"
					:text="$t('export')"
					color="trv-default"
					semantic-class="tiny"
					width-auto
					@click="exportar"
				/>
			</div>
		</div>
	</LayoutExportacao>
</template>

<script>
import LayoutExportacao from '../../../layouts/LayoutExportacao.vue'

import CheckboxGroup from '../../../components/CheckboxGroup/CheckBoxGroup'
import DatePickerInterval from '../../../components/DatePickerInterval/DatePickerInterval'
import ButtonUI from '../../../components/ui/button/Button'
import {
	getParcelaCsv,
	getDropdownFazendaEstratoFlorestal,
	BuscaFiltros,
} from '../../../services/requests/ExportacaoRequests'
import BaseTableWithPagination from '../../../components/BaseTableWithPagination/BaseTableWithPagination'
import Dropdown from '../../../components/ui/dropdown/Dropdown'
import { useMessagesStore } from '../../../store/modules/moduleMessages.js'
import ClearFiltersButton from '../../../components/ClearFiltersButton/ClearFiltersButton.vue'

const messagesStore = useMessagesStore()

export default {
	components: {
		CheckboxGroup,
		DatePickerInterval,
		ButtonUI,
		BaseTableWithPagination,
		Dropdown,
		LayoutExportacao,
		ClearFiltersButton,
	},
	data() {
		return {
			isActive: false,
			dropdown: [],
			data: [],
			fazendasEscolhidas: [],
			estratosEscolhidos: [],
			selectedItems: [],
			dataSelecionada: { startDate: '', endDate: '' },
			labels: [
				{
					id: 'install',
					label: this.$t('instalationInventory'),
					value: 'Inventário de Instalação',
				},
				{ id: 'continuous', label: this.$t('continueInventory'), value: 'Inventário Contínuo' },
				{
					id: 'precut',
					label: this.$t('inventarioPreCorte'),
					value: 'Inventário Pré-Corte',
					disabled: false,
				},
			],
			selectedExportOptions: [],
			colunas: [
				{ nome: this.$t('code'), key: 'processamentoCodigo', enableSort: true },
				{
					nome: this.$t('descricaoDoProcessamento'),
					key: 'processamentoDescricao',
					enableSort: true,
				},
				{
					nome: this.$t('processingDate'),
					key: 'processamentoData',
					tipo: 'date',
					enableSort: true,
				},
				{ nome: 'Status', key: 'processamentoOficial', enableSort: true },
				{ nome: this.$t('codigoDeMedicao'), key: 'medicaoCodigo', enableSort: true },
				{
					nome: this.$t('descricaoDaMedicao'),
					key: 'medicaoDescricao',
					tipo: 'date',
					enableSort: true,
				},
				{ nome: this.$t('dataDaColeta'), key: 'dataColeta', tipo: 'date', enableSort: true },
				{ nome: this.$t('inventoryType'), key: 'tipoServicoDescricao', enableSort: true },
			],
		}
	},
	computed: {
		fazendas() {
			const mapa = new Map()
			return this.dropdown
				.filter((m) => {
					if (!mapa.has(m.fazendaNome)) {
						mapa.set(m.fazendaNome, true)
						return true
					}
					return false
				})
				.map((m) => Object.assign({}, m, { label: m.fazendaNome, value: m.fazendaId }))
		},
		estratos() {
			const estratos = []
			const fazendas = this.dropdown.filter((f) => this.fazendasEscolhidas.includes(f.fazendaId))

			fazendas.forEach((el) => {
				estratos.push({ label: el.estratoFlorestalDescricao, value: el.estratoFlorestalId })
			})

			console.log(estratos)
			return estratos
		},

		dadoFormatado() {
			const formattedData = {
				TipoExportacao: 'Default',
				Processamento: this.selectedItems.map((item) => ({
					EstratoInventarioFlorestalId: item.id,
					Codigo: item.processamentoCodigo.toString(),
					Descricao: item.processamentoDescricao,
				})),
			}

			return formattedData
		},
	},
	async created() {
		const response = await getDropdownFazendaEstratoFlorestal()
		console.log('🚀 ~ file: InventarioArvore.vue ~ line 59 ~ created ~ response', response)
		this.dropdown = response.data
	},
	methods: {
		async exportar() {
			if (this.selectedItems.length === 0) {
				alert('Selecione pelo menos um item para exportar.')
				return
			}
			const response = await getParcelaCsv(this.dadoFormatado)
			var a = document.createElement('a')
			a.target = '_blank'
			a.href = response.data
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			console.log('🚀 ~ file: InventarioArvore.vue ~ line 68 ~ export ~ response', response)
		},

		async filtrar() {
			try {
				this.isActive = true
				const payload = {
					FazendasIds: this.fazendasEscolhidas ?? [],
					EstratoFlorestaisIds: this.estratosEscolhidos ?? [],
					DataMedicaoInicial: this.dataSelecionada.startDate || null,
					DataMedicaoFinal: this.dataSelecionada.endDate || null,
					TipoProcessamentoFlorestal: this.selectedExportOptions ?? [],
				}

				const response = await BuscaFiltros(payload)

				if (response.data.length === 0) {
					this.isActive = false
					messagesStore.commit('mutationShowMessage', {
						messageTitle: this.$t('atention'),
						messageText: this.$t('selectedFilter'),
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
					return
				}
				this.data = response.data
				this.isActive = false
			} catch {
				this.isActive = false
				messagesStore.commit('mutationShowMessage', {
					messageTitle: this.$t('error'),
					messageText: this.$t('anErrorOcurredSearchingProcessing'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},
		handleDateChange(newValue) {
			console.log('🚀 Nova data selecionada:', newValue)
			this.dataSelecionada = newValue
		},
		handleEdit(id) {
			console.log('Editar item:', id)
		},
		handleSortOptions(sortOptions) {
			console.log('Opções de ordenação:', sortOptions)
		},
		handleSelectionChange(newSelection) {
			this.selectedItems = newSelection.selectedItems
		},
		limparFiltros() {
			this.fazendasEscolhidas = []
			this.estratosEscolhidos = []
			this.selectedExportOptions = []
			this.dataInicial = ''
			this.dataFinal = ''
			this.selectedItems = []
			this.data = []
			this.dataSelecionada = {
				startDate: '',
				endDate: '',
			}
		},
	},
}
</script>

<style scoped>
.container__crud {
	width: 100%;
	max-width: 1500px;
}
</style>
